module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit":"Edit","delete":"Delete","question":"Question","answer":"Answer","close":"Close","save":"Save","deleteWarning":"Are you sure you want to delete the question?","yes":"Yes","no":"No"}}')
  delete Component.options._Ctor
}
